export default __webpack_public_path__ + "static/media/begambleawareorg_white.9fd7ba45.png";